<modal
  class="modal-size-sm item-count-validation-modal"
  (click)="closeOnBackdropClick($event)"
>
  <modal-content class="content-aligned-left">
    <section class="item-count-validation-modal__content">
      <strong>{{I18n.ItemCountStrings.InventoryItemName | translate}}:</strong>
      <p>{{ itemName }}</p>
      <strong>{{I18n.ItemCountStrings.InventoryItemID | translate}}:</strong>
      <p>{{ itemId }}</p>
    </section>
  </modal-content>
  <modal-footer>
    <button class="x_confirm-btn x_secondary" (click)="closeModal()">
      {{ closeButtonText | translate }}
    </button>
  </modal-footer>
</modal>
